import React, {useState} from "react";
import Button from "reactstrap/lib/Button";
import Form from "reactstrap/lib/Form";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalHeader from "reactstrap/lib/ModalHeader";
import {t} from "react-switch-lang";
// import './Modals.css';
import './Modals.scss';

import {DeleteNotificationApi} from "../../services/notifications/NotificationsApi";
import Exclusion from "./img/Exclusion 2.svg";
import trashWhite from "../navbar/images/TrashWhite.svg"
import trash2 from "./img/trash-2.svg"

export function DeleteNotification(props) {
    const [modal, setModal] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const userModal = () => setModal(!modal);

    const handleSubmit = event => {
        event.preventDefault();
        DeleteNotificationApi(props.id).then((res) => {
            props.setRowChanged();
            setModal(!modal);
            setIsButtonDisabled(false);
            if (props.type === "bigCalendar") {
                props.setNotificationModal(false)
            }
        })
    };

    return (
        <>
            {props.type === "bigCalendar"
                ? <button className="deleteNotificationCalendar"
                          onClick={userModal}>
                    <img src={trash2} alt="delete"/>
                </button>
                : <button className="deleteNotification" onClick={userModal}>
                    <img src={trashWhite} alt="delete"/>
                </button>
            }

            <Modal isOpen={modal} toggle={userModal}
                   className="modal-md modalDelete" backdrop="static">
                <ModalHeader toggle={userModal}>
                    <div>{t('notification.deleteNotification')} </div>
                    <img src={Exclusion} alt="Exclusion" onClick={userModal}
                         style={{cursor: "pointer"}}/>
                </ModalHeader>
                <ModalBody className="d-flex flex-row">
                    <div>
                        <div className="row">
                            <div className="py-2 my-2">
                                <h3> {`${t('question.delete2')} ${props.subject} ?`}</h3>
                            </div>
                            <div
                                className="container-fluid decorationLine"></div>
                            <div className="text-right offset-5">
                                <Button onClick={userModal}
                                        className="danger cancelButton">
                                    {t('buttons.cancelBtn')}
                                </Button>
                            </div>
                            <div className="text-right">
                                <Form onSubmit={(e) => handleSubmit(e)}
                                      noValidate
                                      className="d-flex justify-content-between">
                                    <Button className="primary deleteButton"
                                            disabled={isButtonDisabled}>
                                        {t("buttons.deleteBtn")}{" "}
                                    </Button>
                                </Form>
                            </div>

                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}
